import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import moment from 'moment';
import { PageHeader, Menu, Dropdown, Button, Tag, Card, Row, Col } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

import {getFees} from '../actions/fee';
import { nairaformat } from '../actions/common';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const Reports = (props) => {

    const nav = useNavigate()
    const loc = useLocation()
    let pr = useParams()
    let sessionid = pr.index1
    const {mid} = props || ''
    const [sessions, setsessions] = useState({})

    let val = loc.state
    let {data, classdata, reportname} = val
    let {termid} = data

    //let {} = useSelector(state=>state.sessionReducer)
   
    console.log(val)
   
    
    const get_rows = (id, arrays) =>{
         return arrays[id]
    }
    const summer = (arr) =>{
        let a = arr.reduce((a, b) =>a + b, 0)
        return a;
    }
    const differ = (arr, arr1) =>{
        let a = arr.reduce((a, b) =>a + b, 0)
        let b = arr1.reduce((a, b) =>a + b, 0)
        let c = 0
        if(a > b){
            c = a - b
            return c
        }else if(b > a){
            return  b - a
        }else{
            return 0
        }
    }
  
    let arr_reports = []
    Object.keys(props.reports).forEach(schoolid=>{
        let sessions = props.reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let arr = {}
            let sch = get_rows(schoolid, props.schools)
            let ses = get_rows(sessionid, props.sessions)
            arr['schoolname'] = sch.abbrv || ''
            arr['sessionname'] = ses.name || ''
            arr['schooldata'] = sch
            arr['sessiondata'] = ses
            arr_reports.push(arr)              
        })
    })
    useEffect(() => {
        
            let params = {
            data:JSON.stringify(
            {
                  'sessionid':sessionid,
                  'studentid' : mid
              }),
              cat:'selected_fee',
              table:'studentscore',
              narration:'get fees'
            }
            props.getFees(params)
    }, [sessionid])
    
    
    const loadResult = (d) =>{
        setsessions(d.sessiondata)
        let session = d.sessiondata.id
            let params = {
            data:JSON.stringify(
            {
                  'sessionid':sessionid,
                  'studentid' : mid
              }),
              cat:'selected_fee',
              table:'studentscore',
              narration:'get fees'
            }
            props.getFees(params)

    }
    const menu = (
        <Menu>
            {
                arr_reports.map((prop, index)=>{
                    return <Menu.Item 
                        key={index} 
                        onClick={()=>loadResult(prop)}
                    >
                      {`${prop.schoolname} ${prop.sessionname}`}
                  </Menu.Item>
                })
            }
        </Menu>
      );

    const DropdownMenu = () => (
        <Dropdown key="more" overlay={menu}>
          <Button>
            <EllipsisOutlined
              style={{
                fontSize: 20,
                verticalAlign: 'top',
              }} 
            /> Select Fees
          </Button>
        </Dropdown>
    );

    const student_fees = Array.isArray(props.fee) ? props.fee || [] : []
    let fee_arr = []
    let paid_arr = []
    const tabl = student_fees.map((prop, index)=>{
        const {
            termname,
            staffname,
            feename,
            datepaid,
            teller,
            date_updated,
            accountname,
            amount,
            grp
        } = prop || ''
        let fee = '-'
        let paid = '-'
        
        if(grp == 0){
            fee_arr.push(parseFloat(amount))
            fee = amount
        }
        if(grp == 1){
            paid_arr.push(parseFloat(amount))
            paid = amount
        }
        
        return <tr key={index}>
            <td>{index + 1}</td>
            <td className="text-left">{termname}</td>
            <td className="text-left">{feename}</td>
            <td className="text-left">{accountname}</td>
            <td>{teller}</td>
            <td>{nairaformat(fee)}</td>
            <td>{nairaformat(paid)}</td>
            <td>{staffname}</td>
            <td className="text-right">{moment(datepaid).format('Do MMM YYYY')}</td>
            <td className="text-right">{date_updated}</td>
        </tr>
    })
    
    return (
        <div>
            <PageHeader
                title="Fees"
                className="site-page-header no-print"
                subTitle={sessions.name || '-'}
                tags={<Tag color="blue">Active</Tag>}
                extra={[
                    <Button onClick={()=>nav(-1)}>Go Back</Button>,
                ]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/fee.png' }}    
            ></PageHeader>
            <Card>
                <h2 className="text-left">{`${reportname}`}</h2>
                <h5 className="text-left">{`${moment(sessions.started).format('Do MMM YYYY')} to ${moment(sessions.ended).format('Do MMM YYYY')} `}</h5>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" xs={24} xl={8}>
                <Card >
                    <Row>
                    <Col span={4}>
                    <img 
                        height='30px'
                        alt="school logo" 
                        src={process.env.PUBLIC_URL+'/asset/icons/fee.png'} 
                        onError={(e)=>{
                            e.target.onerror=null; 
                            e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                        } }
                        />
                    </Col>
                    <Col span={20}>
                    <h3>{nairaformat(summer(fee_arr))}</h3>
                    <h6>Total Fee</h6>
                    </Col>
                    </Row>
                </Card>
                </Col>
                <Col className="gutter-row" xs={24} xl={8}>
                <Card >
                    <Row>
                    <Col span={4}>
                    <img 
                        height='30px'
                        alt="school logo" 
                        src={process.env.PUBLIC_URL+'/asset/icons/account.png'} 
                        onError={(e)=>{
                            e.target.onerror=null; 
                            e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                        } }
                        />
                    </Col>
                    <Col span={20}>
                    <h3>{nairaformat(summer(paid_arr))}</h3>
                    <h6>Total Paid</h6>
                    </Col>
                    </Row>
                </Card>
                </Col>
                <Col className="gutter-row" xs={24} xl={8}>
                <Card >
                    <Row>
                    <Col span={4}>
                    <img 
                        height='30px'
                        alt="school logo" 
                        src={process.env.PUBLIC_URL+'/asset/icons/expense.png'} 
                        onError={(e)=>{
                            e.target.onerror=null; 
                            e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                        } }
                        />
                    </Col>
                    <Col span={20}>
                    <h3>{differ(fee_arr, paid_arr)}</h3>
                    <h6>Balance</h6>
                    </Col>
                    </Row>
                </Card>
                </Col>
            </Row>
            <Row>
                <table width="100%" border="3px solid #ccc" style={{border:'2px solid #ccc'}}>
                    <thead>
                        <tr>
                            <th>S/N</th>
                            <th>Term</th>
                            <th>Title</th>
                            <th>Account</th>
                            <th>Teller</th>
                            <th>Fee Amount</th>
                            <th>Paid Amount</th>
                            <th>Recorded By</th>
                            <th>Date Paid</th>
                            <th>Date Recorded</th>
                        </tr>
                    </thead>
                    {tabl}
                    <tfoot>
                        <tr>
                            <th>S/N</th>
                            <th>Term</th>
                            <th>Title</th>
                            <th>Account</th>
                            <th>Teller</th>
                            <th>{nairaformat(summer(fee_arr))}</th>
                            <th>{nairaformat(summer(paid_arr))}</th>
                            <th>Recorded By</th>
                            <th>Date Paid</th>
                            <th>Date Recorded</th>
                        </tr>
                    </tfoot>
                </table>
            </Row>
            </Card>

            
        </div>
    )
}

const mapStateToProps = (state) => ({
    reports:state.reportReducer.reports,
    fee:state.feeReducer.fees,
    schools:state.reportReducer.schools,
    sessions:state.reportReducer.sessions,
    studentreport:state.studentreportReducer.studentreports,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getFees
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
